<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-primary btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{this.$route.name}}</a>
        <div class="navbar-left" style="margin-top: 20px;">
          <drop-down>
            <button slot="title" class="btn btn-block dropdown-toggle" data-toggle="dropdown">
              {{ accountData.activeBrand.data.name }}
              <b class="caret"></b>
            </button>
            <li v-for="brand in accountData.brands" :key="brand.id"><a href="javascript:void(0)" @click.prevent="selectBrand(brand.id)">{{ brand.data.name }}</a></li>
          </drop-down>
        </div>
      </div>
      <div class="collapse navbar-collapse">
        <form class="navbar-form navbar-left navbar-search-form" role="search">
          <div class="input-group">
            
          </div>
        </form>
      </div>
    </div>
  </nav>
</template>
<script>
  import {Button} from 'element-ui'
  import { EventBus } from '@/eventBus'
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  
  export default {
    props: ['accountData'],
    components: {
      [Button.name]: Button
    },
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      },
      async selectBrand (brandId) {
        if (this.accountData.activeBrand.id === brandId) return false
        await db.collection('users').doc(this.accountData.authDetails.user.id).update({activeBrandId: brandId})
        EventBus.$emit('auth-refreshed')
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue